import React, { createContext, useCallback, useContext, useState } from "react";
import { useAuth } from "./auth";
import { clearAppStorage } from "./appStorage";
import { invalidateAllApiCache } from "./apiCache";
import { devSwitchPersona, DEV_AUTH_ENABLED } from "./devAuth";
import { useGuestIdentity } from "./guestIdentity";

const DevSessionCtx = createContext({ switching: false, switchPersona: async () => null });

export const useDevSession = () => useContext(DevSessionCtx);

export function DevSessionProvider({ children }) {
  const { signIn } = useAuth();
  const { bindDancerId, clearGuest } = useGuestIdentity();
  const [switching, setSwitching] = useState(false);

  const switchPersona = useCallback(
    async (kind, personaId) => {
      if (!DEV_AUTH_ENABLED) return null;
      setSwitching(true);
      try {
        clearAppStorage();
        await invalidateAllApiCache();
        const data = await devSwitchPersona(kind, personaId);
        signIn({ token: data.token, account: data.organizer });
        if (data.dancer_id) {
          bindDancerId(data.dancer_id);
        } else {
          clearGuest();
        }
        return data;
      } finally {
        setSwitching(false);
      }
    },
    [signIn, bindDancerId, clearGuest]
  );

  return (
    <DevSessionCtx.Provider value={{ switching, switchPersona }}>
      {children}
    </DevSessionCtx.Provider>
  );
}
